import { TaellevaerkType } from "./taellevaerk-type.model";

export class MaalerType {
    public id: number;
    public tekst: string;
    public fabrikat: string;
    public taellevaerker: TaellevaerkType[];
    public passiv: boolean;
}

export function opretTomMaalerType(): MaalerType {
    return {
        id: 0,
        tekst: "",
        fabrikat: "",
        taellevaerker: [] as TaellevaerkType[],
        passiv: true
    };
}
